<template>
  <div>
    <!-- HEADER WITH MAINNAV: CONTACT-, WEBSITE- AND SERVICE-NAVIGATION -->

    <header>
      <div>
        <MenuMain />
      </div>
    </header>

    <!-- ASIDE LEFT - CONTENT NAV -->

    <ContainerFlex>
      <div slot="aside-left" class="hidden lg:block">
        <AsideLeft>
          <template slot="title"> Dienstleistungen </template>
          <li
            v-for="service in services"
            :key="service.id"
            class="category-left transition"
          >
            <nuxt-link :to="service.url" class="cursor-pointer">
              {{ service.title }}
            </nuxt-link>
          </li>
        </AsideLeft>
      </div>

      <!-- CENTER - BLOGPOSTS -->

      <template slot="main-content">
        <div class="mt-4 lg:mt-0 mx-4 lg:mx-0">
          <div class="w-full bg-grey-lighter mb-4 p-6 text-white">
            <Paragraph>
              <h4>
                {{ title }}
              </h4>
              <h3 class="text-blue-darker">
                {{ subtitle }}
              </h3>
              <!-- eslint-disable-next-line -->
              <div class="text-blue-dark" v-html="content" />
            </Paragraph>
          </div>
          <div>
            <ContentCard
              v-for="reference in references"
              :key="reference.id"
              is-blog-post
              :href="reference.url"
              class="wow fadeIn"
              data-wow-duration="0.5s"
            >
              <template slot="img">
                <img
                  class="special-img-lg"
                  :src="reference.image"
                  alt="post image"
                />
              </template>
              <template slot="name">
                {{ reference.title }}
              </template>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div
                v-if="reference.summary"
                class="text-sm leading-custom mt-4"
                v-html="reference.summary"
              />
            </ContentCard>
          </div>
        </div>
      </template>

      <!-- ASIDE RIGHT -->

      <template slot="aside-right">
        <AsideRight :coworker="consulter" />
      </template>
    </ContainerFlex>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MenuMain from '~/components/menu/MenuMain'

import ContainerFlex from '~/components/layoutelements/ContainerFlex'
import AsideLeft from '~/components/layoutelements/AsideLeft'
import AsideRight from '~/components/layoutelements/AsideRight'
import Paragraph from '~/components/Paragraph'
import ContentCard from '~/components/cardtypes/ContentCard'

export default {
  components: {
    MenuMain,

    ContainerFlex,
    AsideLeft,
    AsideRight,
    Paragraph,
    ContentCard,
  },

  async asyncData({ route, $axios }) {
    const result = await $axios.$get(route.path)
    return result
  },

  computed: {
    ...mapState('settings', ['services']),
  },
}
</script>
